import axios, { HttpStatusCode } from "axios";
import eventEmitter from "./eventEmitter";
import localStorageService from "../services/localStorageService";

type TrialBlockDetail = {
  code?: string;
  message?: string;
};

let isSetup = false;
let lastTrialEmitAt = 0;

function maybeEmitTrialExpired(error: any) {
  const status = error?.response?.status;
  const detail: TrialBlockDetail | undefined = error?.response?.data?.detail;

  if (status === HttpStatusCode.Forbidden && detail && typeof detail === "object") {
    if (detail.code === "TRIAL_EXPIRED") {
      const now = Date.now();
      if (now - lastTrialEmitAt > 800) {
        lastTrialEmitAt = now;
        eventEmitter.emit("trial_expired", {
          code: detail.code,
          message:
            detail.message ||
            "Your trial has ended . Please upgrade to continue accessing our platform",
        });
      }
    }

    if (detail.code === "SUBSCRIPTION_EXPIRED") {
      eventEmitter.emit("subscription_expired", {
        code: detail.code,
        message: detail.message || "Subscription required to access this sport.",
      });
    }

    if (detail.code === "TEAM_SEAT_OVERFLOW") {
      eventEmitter.emit("team_seat_overflow", {
        code: detail.code,
        message:
          detail.message ||
          "Access is currently unavailable because your team has reached the maximum number of allowed users. Please contact your team administrator to request access.",
      });
    }
  }
}

export default function setupInterceptors() {
  if (isSetup) return;
  isSetup = true;

  // Global axios interceptor: covers services that use axios directly.
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      maybeEmitTrialExpired(error);

      if (error?.response?.status === HttpStatusCode.Unauthorized) {
        // Avoid forcing a redirect on expected 401s like "bad login".
        // Only treat 401 as "session expired" if the app believes the user is logged in.
        const userInfo = localStorageService.getUserInfo?.();
        const token = userInfo?.access_token || userInfo?.token;
        const isAuthed = Boolean(token) || Boolean(localStorage.getItem("sid_user"));
        if (isAuthed) eventEmitter.emit("unauthorized");
      }

      return Promise.reject(error);
    }
  );
}
